import React from 'react'
import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import {hasImage} from '@wix/wix-events-commons-statics'
import {EventImage} from '../../../event-image'
import s from './image.scss'
import {ImageProps} from '.'

export const Image = ({event}: ImageProps) => (
  <div data-hook={hasImage(event) ? DH.listImage : DH.listImagePlaceholder} className={s.image}>
    <EventImage event={event} backgroundFallback />
  </div>
)
